import { render, staticRenderFns } from "./Toasts.vue?vue&type=template&id=3ccbed0c&scoped=true"
import script from "./Toasts.vue?vue&type=script&lang=ts"
export * from "./Toasts.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ccbed0c",
  null
  
)

export default component.exports